import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/')({
  component: lazyRouteComponent(() => import('@/pages/dashboard/page'), 'DashboardPage'),
})
